<template>
    <div class="dovResource">
        <div
         v-for="(item, index) in doc"
         :key="index">
            <iframe
             :class="item.type == '课件'? 'webOffice365 ppt' : 'webOffice365'"
             :src="`//ow365.cn/?i=${institutionConfig.webOffice365Account}&furl=${item.encryptionUrl}`"
             width="100%"
             frameborder="0"/> 
        </div>
    </div>
</template>
<script>
export default {
    props: ['doc'],
    created() {
        console.log(this.doc)
    }
}
</script>
<style lang="scss">
.dovResource{
  overflow: auto;
  .webOffice365{
        width: 100%;
        overflow: auto;
        min-height: 600px;
        margin: 0 auto;
    }
    .ppt {
        min-height: 500px;
    }
}
@media (max-width: 880px) { 
    .ppt {
        min-height: 300px;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/resource/docResource.vue